module.exports = __webpack_public_path__ + "img/about.d8883edf.webp";